
import { MinusIcon, PencilIcon } from "@heroicons/vue/24/solid";
import { useElementSize } from "@vueuse/core";
import { defineComponent } from "vue";
import { ref } from "vue";
import DailyReportRepository from "@/repositories/DailyReportRepository";
import logger from "@/services/logger";
import { WeatherPlotResponse } from "@/types/DailyReport";

let Plotly: typeof import("plotly.js-dist-min") | null = null;
const container = ref(null as HTMLElement | null);
const { width } = useElementSize(container);

export default defineComponent({
  props: ["date", "siteDuration", "editMode", "highlightSection", "approved", "validationError"],
  emits: ["activeEditMode", "addHighlight", "updateSiteDuration"],
  components: {
    PencilIcon,
    MinusIcon,
  },
  data() {
    return {
      openLoader: false,
      startTime: "",
      endTime: "",
      open: false,
      observer: null,
      isContrastActive: false,
      loading: false,
    };
  },
  computed: {
    today() {
      return this.date.split("-").reverse().join(".");
    },
  },
  async mounted() {
    const [weatherResponse] = await Promise.all([this.getWeather(), this.loadPlotly()]);
    if (weatherResponse) {
      this.drawPlot(weatherResponse);
    }
  },
  beforeUnmount() {
    const graph = document.getElementById("chart-container");
    if (graph) {
      Plotly?.purge(graph);
    }
  },
  methods: {
    async loadPlotly() {
      Plotly = await import("plotly.js-dist-min").catch((error) => {
        logger.error(error);
        return null;
      });
    },
    getWeather() {
      const lang = localStorage.getItem("lang") || "de";

      return DailyReportRepository.getDailyReportWeatherPlot(
        this.currentCustomerName,
        this.currentSiteId,
        this.date,
        lang,
      ).catch((error) => {
        logger.error(error);
        return null;
      });
    },
    drawPlot(response: WeatherPlotResponse) {
      const data = JSON.parse(response["plot"]).data;
      const layout = JSON.parse(response["plot"]).layout;
      layout.height = 200;
      layout.width = width.value;

      const graphDiv = document.getElementById("chart-container");
      if (!graphDiv) {
        return;
      }
      const config = { responsive: true, displayModeBar: false };
      Plotly?.newPlot(graphDiv, data, layout, config);
    },
  },
});
